<template>
  <div>
    <Row :gutter="23">
      <i-col :xs="12" :md="8" :lg="4" v-for="(infor, i) in inforCardData" :key="`infor-${i}`" style="height: 120px;padding-bottom: 10px;margin-top: 10px;margin-left: 3.5rem">
        <infor-card shadow :color="infor.color" :icon="infor.icon" :icon-size="40">
          <count-to :end="infor.count" count-class="count-style"/>
          <p>{{ infor.title }}</p>
        </infor-card>
      </i-col>
    </Row>
    <Row :gutter="20" style="margin-top: 10px;">
<!--      <i-col :md="24" :lg="8" style="margin-bottom: 20px">-->
<!--        <Card shadow>-->
<!--          <chart-pie style="height: 320px;" :value="pieData" @echart = 'echart' @options="options" text="商品月销量（件）"></chart-pie>-->
<!--        </Card>-->
<!--      </i-col>-->
      <i-col :md="24" :lg="16" style="margin-bottom: 20px">
        <Card shadow>
          <chart-bar style="height: 320px;"  @echart2 = 'echart2' @options2="options2" text="用户月新增（人）"/>
        </Card>
      </i-col>
    </Row>
    <Row>
      <Card shadow>
        <example style="height: 310px;"/>
      </Card>
    </Row>
  </div>
</template>

<script>
import InforCard from '_c/info-card'
import CountTo from '_c/count-to'
import { ChartPie, ChartBar } from '_c/charts'
import Example from './example.vue'
import userChart from './components/userChart'
import { topStatis, goodsStatis, userStatis } from '@/api/home'
export default {
  name: 'home',
  components: {
    InforCard,
    CountTo,
    ChartPie,
    ChartBar,
    Example,
    userChart
  },
  data () {
    return {
      echarts: null,
      option: null,
      echarts2: null,
      option2: null,
      inforCardData: [
        { title: '本月新增用户', icon: 'ios-person', count: 0, color: '#2d8cf0' },
        { title: '用户总数', icon: 'ios-person', count: 0, color: '#19be6b' },
        { title: '订单数', icon: 'ios-cart', count: 0, color: '#ff9900' },
        // { title: '总业绩', icon: 'ivu-icon ivu-icon-md-basket', count: 0, color: '#ed3f14' }
      ],
      pieData: [
        { value: 0, name: '普通商品' },
        { value: 0, name: '积分商品' }
      ]
    }
  },
  created () {
    this.headStatis()
    this.goodsStatis()
    this.userStatis()
  },
  methods: {
    // 顶部统计
    headStatis () {
      this.loading = true
      topStatis().then(res => {
        let data = res.data
        this.inforCardData[0]['count'] = data.userNumForMonth
        this.inforCardData[1]['count'] = data.userNum
        this.inforCardData[2]['count'] = data.orderNum
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },

    goodsStatis () {
      this.loading = true
      goodsStatis().then(res => {
        let data = res.data
        this.pieData[0]['value'] = Number(data.maxNomalOrder)
        this.pieData[1]['value'] = Number(data.maxPointOrder)
        this.echarts.setOption(this.option)
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },

    userStatis () {
      this.loading = true
      userStatis().then(res => {
        let data = res.data
        this.option2.xAxis['data'] = data.arr_date
        this.option2.series[0]['data'] = data.arr_num
        this.echarts2.setOption(this.option2)
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    echart (val) {
      this.echarts = val
    },
    options (val) {
      this.option = val
    },
    echart2 (val) {
      this.echarts2 = val
    },
    options2 (val) {
      this.option2 = val
    }
  }
}
</script>

<style lang="less">
  .count-style{
    font-size: 25px;
  }
  .ivu-col-span-lg-4 {
    display: block;
    width: 22%;
  }
</style>
